module.exports = __webpack_public_path__ + "static/media/expand.42b50fae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/expand.svg
// module id = 1067
// module chunks = 0